/*
 * File: locale.ts
 * Airbus, 2024
 * Author: CMIS FE
 * Description: CMIS APP Locale
 * Copyright (C) 2023-2024 CMIS APP
 * Project: CMIS APP
 * Description: Defines localization constants for Configuration Cockpit application.
 *
 * This file is part of CMIS APP.
 *
 * CMIS APP is Aviation product:
 * Used in the latest version
 * CMIS APP is an aviation product used in the latest version.
 *
 * CMIS APP FE Code
 *
 * This belong to with CMIS APP.
 * Copyright (c) 2023-2024 CMIS APP
 * All rights reserved.
 *
 * Author: CMIS FE
 * Created: 2024
 */
export const LOCALES = {
  APP_NAME: 'Configuration Cockpit',
  APP_POWERED_BY: '- Powered by',
};
